import { isPatientApp } from '@/config/constants';

const colors = {
  primary: '#51bf92',
  primaryBrighter: '#98d9bf',
  white: '#FFFFFF',
  black: '#000000',
  medium: '#555555',
  link: '#1e88e5',
  grey: '#eeeeee',
  mediumGrey: '#dddddd',
  lightGrey: '#fafafa',
  darkGrey: '#49475b',
  gold: '#FFD700',
  darkPurpleBlue: '#5B79EC',
  red: '#e53935',
  borderColor: '#6d6c7c',
  yellow: '#ffc400',
  green: '#43a047',
  fontColor: '',
  darkerGrey: 'rgb(206, 206, 206)',
  darkestGrey: '#3a3a3a',
  link2: '#62B0C7',
  lightBlue: '#F0F4F9',
  darkBlue: '#241862',
  twGrey: '#d4d4d4',
};

const newUI = {
  therapist: {
    bgBlue10: '#EEF4FD',
    blue20: '#DEE5F2',
    blue50: '#728CC5',
    blue60: '#4E6FB6',
    blue90: '#1F2D4C',
    brandGreen: '#51BF92',
    green10: '#E8F6F1',
    green30: '#C3E9DA',
    green70: '#3CA47A',
    green90: '#215942',
    grey20: '#F0F0F0',
    grey30: '#E1E1E1',
    grey50: '#A5A5A5',
    grey60: '#878787',
    grey70: '#696969',
    orange30: '#FFD199',
    orange40: '#FFBA66',
    orange60: '#FF8C00',
    orange90: '#663800',
    primaryBlue10: '#F0F3F9',
    primaryBlue50: '#728CC5',
    primaryBlue60: '#4E6FB6',
    primaryBlue80: '#2E4370',
    red30: '#F4AFAF',
    red50: '#E95654',
    red70: '#BE1B19',
    red90: '#640E0D',
    textBlue100: '#101828',
    shadow: '#2C416D',
    yellow10: '#FFF4E0',
    yellow90: '#E08C01',
  },
};

export const appTheme = isPatientApp
  ? {
      light: newUI.therapist.green10,
      medium: newUI.therapist.green70,
      primary: colors.primary,
      textColor: colors.black,
    }
  : {
      light: newUI.therapist.primaryBlue10,
      medium: newUI.therapist.primaryBlue60,
      primary: newUI.therapist.primaryBlue80,
      textColor: newUI.therapist.textBlue100,
    };

const theme = {
  fontFamilies: {
    exerciseFont: 'ABeeZeeRegular',
  },
  colors: { ...colors, newUI },
  spacings: {
    none: 0,
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    '2xl': 48,
    '3xl': 64,
  },
  fontSizes: {
    xs: 12,
    sm: 14,
    base: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 30,
    '4xl': 36,
    '5xl': 48,
    '6xl': 60,
    '7xl': 72,
    '8xl': 96,
    '9xl': 128,
  },
  borderRadii: {
    sm: 4,
    md: 6,
    lg: 8,
    xl: 12,
    '2xl': 16,
    '3xl': 24,
    full: 9999,
  },
  appTheme,
};

export default theme;
